<template>
  <template v-if="urls.length">
    <img v-for="item in urls" :key="item" class="userAvatar" :src="item" @click="handleUploadAvatar" />
  </template>
  <template v-else>
    <div class="uploadIcon" @click="handleUploadAvatar">
      <el-icon><Plus /></el-icon>
    </div>
  </template>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Plus } from '@element-plus/icons-vue';
import { pickImageList } from '@/provider/upload';
const emits = defineEmits(["update:modelValue"])
const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => []
  },
  count: {
    type: Number,
    default: 1
  }
})

const urls = ref([])

watch(() => props.modelValue, (val) => {
  urls.value = Array.isArray(val) ? val : val ? [val] : []
}, {
  immediate: true
})

function handleUploadAvatar() {
  const { count } = props
  pickImageList({
    count
  }).then(res => {
    if(count == 1) {
      emits('update:modelValue', res[0])
    } else {
      emits('update:modelValue', res)
    }
  })
}
</script>

<style lang="less" scoped>
.userAvatar {
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.uploadIcon {
  width: 80px;
  height: 80px;
  border: 1px dashed @color-border;
  .flexCenter;
  font-size: 26px;
  cursor: pointer;
  &:hover {
    border: 1px dashed @color-primary-select;
  }
}
</style>